const DebtFacilityDelete = () => {
  return (
    <div className="debt-facility-delete">
      <h1>Placeholder for Debt Facility Deletion</h1>
    </div>
  );
};

export default DebtFacilityDelete;
